import { render, staticRenderFns } from "./new-location.vue?vue&type=template&id=504600c9"
import script from "./new-location.vue?vue&type=script&lang=js"
export * from "./new-location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports